<template>
  <div class="album-page">
    <div class="album-page-body">
      <div class="album-name-box">
        <p class="box-title"><span>*</span>专辑名称</p>
        <div class="box-content">
          <div class="name-tip">
            <p>
              同步类：学年+年级+学期/册别+学科+关键词（应用场景、资源类型）+版本/地区
            </p>
            <p>备考类：年份+学科+关键词（应用场景、资源类型）+地区</p>
          </div>
          <el-input
            placeholder="请输入专辑名称"
            v-model="albumInfo.name"
            clearable
            show-word-limit
            :maxlength="50"
            :disabled="$route.query.operationType == 3"
          >
          </el-input>
          <div v-show="itemTips.name" class="must-tip">
            <img
              src="../../../assets/images/must-tip-icon.png"
              alt=""
              class="must-tip-icon"
            />
            <span>必填项</span>
          </div>
        </div>
      </div>
      <div class="album-introduce-box">
        <p class="box-title"><span>*</span>简介</p>
        <div class="box-content">
          <el-input
            type="textarea"
            placeholder="请输入专辑简介，字数50-500"
            v-model="albumInfo.introduce"
            clearable
            :rows="5"
            resize="none"
            maxlength="500"
            minlength="50"
            show-word-limit
            :disabled="$route.query.operationType == 3"
          >
          </el-input>
          <div v-show="itemTips.introduce" class="must-tip">
            <img
              src="../../../assets/images/must-tip-icon.png"
              alt=""
              class="must-tip-icon"
            />
            <span>必填项</span>
          </div>
        </div>
      </div>
      <div class="album-subject-status-box">
        <div class="subject-box">
          <p class="box-title"><span>*</span>学科</p>
          <div class="box-content">
            <el-cascader
              placeholder="请选择学科"
              v-model="albumInfo.subject"
              :options="subjectOptions"
              :props="{
                value: 'id',
                emitPath: false,
              }"
              :show-all-levels="false"
              :disabled="$route.query.operationType == 3"
              @change="changeSubject"
            ></el-cascader>
            <div v-show="itemTips.subject" class="must-tip">
              <img
                src="../../../assets/images/must-tip-icon.png"
                alt=""
                class="must-tip-icon"
              />
              <span>必填项</span>
            </div>
          </div>
        </div>
        <div class="status-box">
          <p class="box-title"><span>*</span>完结状态</p>
          <p class="status-tip">完结后无法再次修改</p>
          <div class="box-content">
            <el-select
              v-model="albumInfo.status"
              placeholder="请选择完结状态"
              :disabled="$route.query.operationType == 3"
            >
              <el-option
                v-for="item in statusOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
            <div v-show="itemTips.status" class="must-tip">
              <img
                src="../../../assets/images/must-tip-icon.png"
                alt=""
                class="must-tip-icon"
              />
              <span>必填项</span>
            </div>
          </div>
        </div>
      </div>
      <div class="album-grade-area-box">
        <div class="grade-box">
          <p class="box-title"><span>*</span>年级</p>
          <div class="box-content">
            <el-select
              v-model="albumInfo.grade"
              multiple
              collapse-tags
              placeholder="请选择年级"
              :disabled="$route.query.operationType == 3"
            >
              <el-option
                v-for="item in gradeOptions"
                :key="item.gradeId"
                :label="item.name"
                :value="item.gradeId"
              >
              </el-option>
            </el-select>
            <div v-show="itemTips.grade" class="must-tip">
              <img
                src="../../../assets/images/must-tip-icon.png"
                alt=""
                class="must-tip-icon"
              />
              <span>必填项</span>
            </div>
          </div>
        </div>
        <div class="status-box">
          <p class="box-title"><span>*</span>地区</p>
          <div class="box-content">
            <el-select
              v-model="albumInfo.area"
              placeholder="请选择地区"
              :disabled="$route.query.operationType == 3"
            >
              <el-option
                v-for="item in areaOptions"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
            <div v-show="itemTips.area" class="must-tip">
              <img
                src="../../../assets/images/must-tip-icon.png"
                alt=""
                class="must-tip-icon"
              />
              <span>必填项</span>
            </div>
          </div>
        </div>
      </div>
      <div class="album-content">
        <p class="box-title"><span>*</span>专辑内容：</p>
        <div class="box-content">
          <div class="add-btn" @click="toShow">
            <i class="iconfont icon-jiahao add-icon"></i>
            <p>添加内容</p>
            <div v-show="itemTips.ids" class="must-tip">
              <img
                src="../../../assets/images/must-tip-icon.png"
                alt=""
                class="must-tip-icon"
              />
              <span>必填项</span>
            </div>
          </div>

          <ul class="content-list" id="content-list">
            <li
              class="content-li"
              v-for="(item, index) in recourseList"
              :key="item.documentId"
            >
              <img
                src="../../../assets/images/sort-icon.png"
                alt=""
                class="sort-icon"
              />
              <div class="content-li-info">
                <img
                  v-if="item._icon"
                  :src="
                    require('../../../assets/images/' +
                      item._icon +
                      '-icon.png')
                  "
                  alt=""
                  class="type-icon"
                />
                <p :title="item.title">{{ item.title }}</p>
                <i
                  class="iconfont icon-guanbi delete-icon"
                  @click="deleteContent(item._type, index, item.documentId)"
                ></i>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <!-- 选择资源弹窗 -->
    <recourseSelectDialog
      :show.sync="showSelectDialog"
      :courseId="albumInfo.subject"
      :selectData="{
        selectedDocuments: documentList,
        selectedVideos: videoList,
      }"
      @confirmSelect="selectRecourse"
    />
    <!-- 上传最终确定的通用弹窗 -->
    <uploadTipDialog
      :show.sync="showUploadTipDialog"
      :dialogContent="dialogContent"
      @toList="toList()"
      @confirm="uploadAlbum()"
    />
    <!-- 底部通栏 -->
    <footer class="footer">
      <div class="cancel" @click="toList(false)">
        {{ $route.query.operationType ? "取消" : "返回" }}
      </div>
      <div class="sure" @click="uploadCheck()">
        {{ $route.query.operationType ? "确定修改" : "确定上传" }}
      </div>
    </footer>
  </div>
</template>

<script>
import Sortable from "sortablejs";
import api from "@/assets/js/api";
import recourseSelectDialog from "@/components/recourse-dialog/recourse-select-dialog.vue";
import uploadTipDialog from "@/components/recourse-dialog/upload-tip-dialog.vue";
import leaveUpload from "../../../mixin/leaveUpload.js";

export default {
  name: "ShopCenterAdminWebAlbumUpload",
  components: {
    recourseSelectDialog,
    uploadTipDialog,
  },
  data() {
    return {
      albumInfo: {
        name: "",
        introduce: "",
        subject: "",
        status: "",
        grade: [],
        area: "",
        ids: [],
      },
      itemTips: {
        // 控制必填提示是否显示
        name: false,
        subject: false,
        introduce: false,
        status: false,
        grade: false,
        area: false,
        ids: false,
      },
      subjectOptions: [], // 学科数据
      gradeOptions: [], // 年级数据
      areaOptions: [], // 地区数据
      statusOptions: [
        // 完结状态数据
        {
          label: "更新中",
          value: "更新中",
        },
        {
          label: "已完结",
          value: "已完成",
        },
      ],
      fileTypes: {
        // 文件允许的类型
        imgTypes: ["jpg", "jpeg", "png"], // 图片类型
        zipTypes: ["zip", "rar"], // 压缩包类型
        officeTypes: [
          "doc",
          "docx",
          "xls",
          "xlsx",
          "ppt",
          "pptx",
          "pdf",
          "ts",
          "chm",
          "wps",
        ], // office类型
        mediaTypes: ["swf", "mp3", "asf", "wma"], // 音频类型
        videoTypes: ["mp4", "avi", "wmv", "mov", "flv", "rmvb", "3gp", "mkv"], // 视频类型
      },
      showSelectDialog: false,
      showUploadTipDialog: false,
      dialogContent: "", // 弹窗文案
      recourseList: [], // 资料和视频
      documentList: [], // 选中的资料
      videoList: [], // 选中的视频
      courseAndStageMap: new Map(), // 学科与学段的哈希映射表
      isSaved: false, // 是否为保存操作 决定是否触发beforeRouteLeave逻辑处理
      activeIndex: "/resource/album/list", // beforeRouteLeave取消路由跳转时 重新设置导航栏的选中状态
    };
  },
  mixins: [leaveUpload], // 路由守卫文件
  async mounted() {
    // 如果是编辑 则获取专辑详情
    if (this.$route.query.resourceId) {
      await this.getAlbumDetail(this.$route.query.resourceId);
    }
    this.getStageAndSubject();
    this.getAreaList();
    // 开启拖拽功能
    this.$nextTick(() => {
      // 开启拖拽排序
      var el = document.getElementById("content-list");
      new Sortable(el, {
        animation: 150,
        filter: ".no-change",
        onUpdate: (evt) => {
          // 改变数组排序
          const temp = this.recourseList[evt.oldIndex];
          this.recourseList.splice(evt.oldIndex, 1);
          this.recourseList.splice(evt.newIndex, 0, temp);
          // 重新按顺序渲染dom 确保视图和数据一致
          const arr = this.recourseList.slice(0);
          this.recourseList = [];
          this.$nextTick(() => {
            this.recourseList = arr;
          });
        },
      });
    });
  },

  methods: {
    // 查询专辑信息
    async getAlbumDetail(id) {
      const res = await this.$axios.get(
        api.shopResource.getAlbumDetail + "?albumId=" + id
      );
      if (res.valid) {
        this.albumInfo.name = res.result.title;
        this.albumInfo.introduce = res.result.description;
        this.albumInfo.subject = res.result.courseId;
        this.albumInfo.status = res.result.updateStatus;
        this.albumInfo.grade = res.result.gradeIds;
        this.albumInfo.area = res.result.provinceId;

        this.recourseList = res.result.documentList
          ? res.result.documentList.map((item) => {
              if (item._type === 1) {
                item = this.getDocumentIcon(item);
                this.documentList.push(item);
              } else {
                item._icon = "video";
                this.videoList.push(item);
              }
              return item;
            })
          : [];
      }
    },
    // 获取学段学科
    async getStageAndSubject() {
      const res = await this.$axios.get(api.shopResource.getStageAndSubject);
      if (res.valid) {
        this.subjectOptions = res.result;
        // 建立学科与学段的哈希映射表
        res.result.forEach((item) => {
          this.setCourseAndStageMap(item.children, item.stageId);
        });
        if (this.albumInfo.subject) {
          this.getGradeList(this.courseAndStageMap.get(this.albumInfo.subject));
        }
      }
    },
    // 递归建立学科与学段的哈希映射表
    setCourseAndStageMap(data, stageId) {
      for (let i = 0; i < data.length; i++) {
        const item = data[i];
        if (!item.children || item.children.length === 0) {
          delete item.children;
          this.courseAndStageMap.set(item.id, stageId);
        } else {
          this.setCourseAndStageMap(item.children, stageId);
        }
      }
    },
    // 获取年级
    async getGradeList(stageId) {
      const res = await this.$axios.get(
        api.shopResource.getGradeList + "?stageId=" + stageId
      );
      if (res.valid) {
        this.gradeOptions = res.result;
      }
    },
    // 获取地区
    async getAreaList() {
      const res = await this.$axios.get(api.shopResource.getAreaList);
      if (res.valid) {
        this.areaOptions = res.result;
      }
    },
    // 修改学科
    changeSubject() {
      // 清空年级
      this.albumInfo.grade = "";
      // 根据学科的学段 获取对应的年级
      this.getGradeList(this.courseAndStageMap.get(this.albumInfo.subject));
    },
    toShow() {
      this.showSelectDialog = true;
    },
    selectRecourse(e) {
      // console.log("选择的内容数据---", e);
      this.documentList = e.selectedDocuments.map((item) => {
        item._type = 1;
        // 根据文件类型决定显示的图标
        item = this.getDocumentIcon(item);
        return item;
      });
      this.videoList = e.selectedVideos.map((item) => {
        item._type = 2;
        item._icon = "video";
        return item;
      });
      if (this.recourseList.length === 0) {
        this.recourseList = [...e.selectedDocuments, ...e.selectedVideos];
      } else {
        [...e.selectedDocuments, ...e.selectedVideos].forEach((item) => {
          const index = this.recourseList.findIndex(
            (item2) => item2.documentId === item.documentId
          );
          if (index === -1) {
            this.recourseList.push(item);
          }
        });
      }
    },
    // 设置资料类型图标
    getDocumentIcon(item) {
      // 根据文件类型决定显示的图标
      const isImg = this.fileTypes.imgTypes.includes(item.fileExt);
      const isZip = this.fileTypes.zipTypes.includes(item.fileExt);
      const isOffice = this.fileTypes.officeTypes.includes(item.fileExt);
      const isMedia = this.fileTypes.mediaTypes.includes(item.fileExt);
      // 根据类型决定显示的图标
      switch (true) {
        case isImg:
          item._icon = "img";
          break;
        case isZip:
          item._icon = "zip";
          break;
        case isOffice:
          item._icon = "office";
          break;
        case isMedia:
          item._icon = "audio";
          break;
        default:
          item._icon = "office";
      }
      return item;
    },
    deleteContent(type, index, id) {
      this.recourseList.splice(index, 1);
      if (type === 1) {
        const i = this.documentList.findIndex((item) => item.documentId === id);
        this.documentList.splice(i, 1);
      } else {
        const i = this.videoList.findIndex((item) => item.documentId === id);
        this.videoList.splice(i, 1);
      }
    },
    // 上传前校验
    uploadCheck() {
      this.albumInfo.ids = this.recourseList.map((item) => item.documentId);
      let isPass = true;
      for (let key in this.itemTips) {
        if (
          (key === "ids" || key === "grade") &&
          this.albumInfo[key].length === 0
        ) {
          this.itemTips[key] = true;
          isPass = false;
        } else if (this.albumInfo[key].toString().trim().length === 0) {
          this.itemTips[key] = true;
          isPass = false;
        } else {
          this.itemTips[key] = false;
        }
      }
      if (!isPass) return;
      // 校验专辑简介字数 50~500 否则就是不合格
      if (
        this.albumInfo.introduce.length > 0 &&
        (this.albumInfo.introduce.length < 50 ||
          this.albumInfo.introduce.length > 500)
      ) {
        this.$message.error("专辑简介字数50-500,请检查~");
        return;
      }
      // 校验专辑的学科与资料/视频的学科是否一致
      const f = this.recourseList.find(
        (item) => item.courseId !== this.albumInfo.subject
      );
      if (f) {
        this.$message.error("专辑学科与资料或视频学科不一致，请检查~");
        return;
      }
      if (this.$route.query.operationType === "1") {
        this.dialogContent = "请确认是否保存此次编辑？";
      } else {
        this.dialogContent = "请确认是否上传该专辑？";
      }
      this.showUploadTipDialog = true;
    },
    // 确定上传
    async uploadAlbum() {
      const params = {
        title: this.albumInfo.name,
        description: this.albumInfo.introduce,
        courseId: this.albumInfo.subject,
        updateStatus: this.albumInfo.status,
        gradeIds: this.albumInfo.grade,
        provinceId: this.albumInfo.area,
        documentIds: this.albumInfo.ids,
        shopId: Number(this.$store.state.user.userInfo.shopId),
      };
      // console.log("要提交的专辑信息---", params);
      let url = api.shopResource.createAlbum;
      let message = "创建成功";
      let errorMessage = "上传失败，请重试或联系客服~";
      // 判断是否为修改操作
      if (this.$route.query.operationType) {
        url = api.shopResource.updateAlbum;
        message = "修改成功";
        errorMessage = "修改失败，请重试或联系客服~";
        params.id = Number(this.$route.query.resourceId);
      }
      const res = await this.$axios.post(url, params);
      // console.log("上传专辑结果---", res);
      if (res.valid && res.result) {
        this.$message.success(message);
        this.toList(true);
      } else {
        this.$message.error(res.error?.message || errorMessage);
      }
    },
    // 返回列表
    toList(f) {
      // 是否触发beforeRouteLeave逻辑处理
      this.isSaved = f;
      this.$router.push({
        name: "resource-album-list",
        params: this.$route.params,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.album-page {
  position: relative;
  width: 100%;
  padding-bottom: 105px;
  .album-page-body {
    width: 950px;
    margin: auto;
    padding: 40px 0px 60px 50px;
    background-color: #fff;
    border-radius: 5px;
    & > div {
      width: 800px;
      margin-bottom: 35px;
      .box-title {
        display: flex;
        align-content: center;
        justify-content: flex-start;
        margin-bottom: 14px;
        color: #606266;
        font-weight: 600;
        span {
          margin-right: 5px;
          color: #fe4509;
          font-weight: 600;
        }
      }
      .box-content {
        position: relative;
        padding-left: 12px;
        .must-tip {
          position: absolute;
          right: -65px;
          bottom: 12px;
          display: flex;
          align-items: center;
          justify-content: center;
          margin-left: 10px;

          .must-tip-icon {
            width: 14px;
            height: 14px;
            margin-right: 4px;
          }

          span {
            font-size: 12px;
            color: #fe4509;
          }
        }
      }
    }
    .album-name-box {
      .box-content {
        .name-tip {
          margin-bottom: 5px;
          color: #c4c8d0;
          font-size: 12px;
          font-style: normal;
          font-weight: 400;
          line-height: 20px; /* 166.667% */
        }
      }
    }
    .album-introduce-box .box-content {
      .must-tip {
        bottom: 50%;
        transform: translateY(50%);
      }
    }
    .album-subject-status-box,
    .album-grade-area-box {
      display: flex;
      align-items: center;
      justify-content: space-between;
      .status-box {
        position: relative;
        .status-tip {
          position: absolute;
          top: 4px;
          left: 83px;
          color: #c4c8d0;
          font-size: 12px;
          font-weight: 400;
          line-height: 12px; /* 100% */
        }
      }
      ::v-deep .el-input {
        width: 300px;
      }
    }
    .album-content {
      .box-content {
        .add-btn {
          position: relative;
          width: 156px;
          height: 32px;
          margin-bottom: 5px;
          border: 1px dashed #a3baff;
          border-radius: 5px;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 12px;
          color: #5a83ff;
          cursor: pointer;
          opacity: 1;

          .add-icon {
            font-size: 12px;
            margin-right: 6px;
          }

          p {
            line-height: 32px;
          }
          .must-tip {
            bottom: 7px;
          }
          &:hover {
            opacity: 0.9;
          }
        }
        .content-list {
          .content-li {
            position: relative;
            display: flex;
            align-items: center;
            justify-content: flex-start;
            padding: 5px 0;
            cursor: pointer;
            .sort-icon {
              position: absolute;
              top: 50%;
              left: -21px;
              transform: translateY(-50%);
              width: 16px;
              height: 16px;
            }
            .content-li-info {
              position: relative;
              display: flex;
              align-items: center;
              justify-content: flex-start;
              width: 100%;
              padding: 10px 32px 10px 14px;
              border-radius: 5px;
              border: 1px solid #dddfe6;
              background: #fff;
              .type-icon {
                width: 14px;
                height: 14px;
                margin: 0 10px 0 0;
              }
              & > p {
                width: 100%;
                color: #606266;
                font-size: 12px;
                font-style: normal;
                font-weight: 400;
                line-height: 12px; /* 100% */
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
              }
              .delete-icon {
                position: absolute;
                right: 14px;
                top: 50%;
                transform: translateY(-50%);
                font-size: 14px;
                margin-left: 10px;
                color: #c4c8d0;
                cursor: pointer;

                &:hover {
                  color: rgba(237, 123, 47, 0.5);
                }
              }
            }
          }
        }
      }
    }
  }
  .footer {
    display: flex;
    align-items: center;
    justify-content: center;
    position: fixed;
    bottom: 0px;
    right: 0px;
    z-index: 8;
    width: calc(100% + 40px);
    height: 70px;
    background-color: #fff;

    .cancel {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 96px;
      height: 32px;
      margin-right: 60px;
      transform: translateX(120px);
      background: #ffffff;
      border: 1px solid #dddfe6;
      border-radius: 3px;
      color: #606266;
      cursor: pointer;
    }

    .sure {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 96px;
      height: 32px;
      transform: translateX(120px);
      color: #fff;
      background: #5a83ff;
      border-radius: 3px;
      cursor: pointer;
    }
  }
}
</style>
